import { holdemAuthReturnPath, holdemRegistrationAgentRid } from "./HoldemRoomInvite";

// Kenya currently supports Holdem room invitations; keep ordinary referral behavior.
export function roomInviteAuthReturnPath(backTo) {
  return holdemAuthReturnPath(backTo);
}

export function roomInviteRegistrationAgentRid(backTo, storedAgentRid) {
  return holdemRegistrationAgentRid(backTo, storedAgentRid);
}
